import { injectAttributesOf } from '@adornis/chemistry/directives/inject-attributes.js';
import { XDropdownSelection } from '@adornis/popover/x-dropdown-selection.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @element tr-dropdown-selection
 */
@customElement('tr-dropdown-selection')
export class TrFormfieldWrapper<T, V> extends XDropdownSelection<T, V> {
  @property({ type: Boolean }) clearable = false;

  @property({ attribute: false }) guardFunction?: (item: T) => string | number | undefined;

  /** Copy of XDropdownSelection._trigger() from @adornis/popover v23.2.5 with only the ?clearable binding added; re-sync when upgrading that dependency. */
  protected override _trigger() {
    if (this.placeholder || !this['use-slot']) {
      const renderSelected = this.hasValue ? this.renderSelected(this.value.value) : this.placeholder;
      return html`
        <x-formfield-wrapper
          ${injectAttributesOf(this, ['tabindex'])}
          icon=${this._icon()}
          ?show-label=${this.showLabel}
          ?clearable=${this.clearable}
          @cleared=${() => this._clear()}
          @icon-click=${() => this.dispatchEvent(new CustomEvent('icon-click'))}
        >
          ${!this.hasValue || typeof renderSelected === 'string'
            ? html`
                <x-text
                  flex
                  tone=${this.hasValue ? '' : 'placeholder'}
                  ellipsis
                  value=${this.hasValue ? this.renderSelected(this.value.value) : this.placeholder}
                >
                </x-text>
              `
            : renderSelected}
        </x-formfield-wrapper>
      `;
    }
    return html` <slot></slot> `;
  }

  protected override _guardTrigger() {
    return [
      this._searchResultSelectables.value
        ?.map(s => (this.guardFunction ? this.guardFunction(s) : this.guardKey ? s[this.guardKey] : s))
        .join(),
      this._preSelectedItem,
      this._loading,
    ];
  }
}
